const AlertDialogStyles = (theme) => ({
    root: {
        flexGrow: 1
    },
    message: {
        fontSize: 14
    },
    cancelButton: {
        color: '#f44336',
        textTransform: 'uppercase'
    }
});

export default AlertDialogStyles;